import _ from 'underscore';
import Api from '@/lib/api/api';
import v5_Collection from '@/collections/v5/collection';
import Invitation from '@/models/v5/invitation';
import v5_Model from '@/models/v5/model';


var Invitations = new v5_Collection();
_.extend(Invitations, {
    url: function() {
        return Api.urls.invitations();
    },
    model: Invitation,
    /**
     * Create an invitation for model, sent to email, with roles.
     * Model could be any type. Early implementations of the Api
     * have only Accounts allowing invitations. Conceivably,
     * any type for which a Grant could be mad can have an invitation.
     */
    create_invitation: function(email, model, roles, options) {
        options = (options || {});
        options.attrs = {
            data: {
                type: Invitation.type,
                attributes: { email: email },
                relationships: {
                    roles: roles.map(v5_Model.make_reference),
                    target: v5_Model.make_reference(model)
                }
            }
        };
        return this.create({ email: email }, options);
    }
});
export default Invitations;

